const RouteTaxiIcon = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 11H0V16C0 17.1046 0.89543 18 2 18H16C17.1046 18 18 17.1046 18 16V11ZM5 14.5C5 15.3284 4.32843 16 3.5 16C2.67157 16 2 15.3284 2 14.5C2 13.6716 2.67157 13 3.5 13C4.32843 13 5 13.6716 5 14.5ZM16 14.5C16 15.3284 15.3284 16 14.5 16C13.6716 16 13 15.3284 13 14.5C13 13.6716 13.6716 13 14.5 13C15.3284 13 16 13.6716 16 14.5Z"
        fill="#17171C"
      />
      <path
        d="M2 18H5V19C5 19.5523 4.55228 20 4 20H3C2.44772 20 2 19.5523 2 19V18Z"
        fill="#17171C"
      />
      <path
        d="M13 18H16V19C16 19.5523 15.5523 20 15 20H14C13.4477 20 13 19.5523 13 19V18Z"
        fill="#17171C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 0C0.895431 0 0 0.89543 0 2V9H18V2C18 0.895431 17.1046 0 16 0H2ZM6 2.5H4V4.5H6V6.5H8V4.5H10V6.5H12V4.5H14V2.5H12V4.5H10V2.5H8V4.5H6V2.5Z"
        fill="#17171C"
      />
    </svg>
  )
}

export default RouteTaxiIcon
